import React from 'react';
import { Outlet } from 'react-router-dom';
import SettingsMenu from '../SettingsMenu';
import './index.css';

export default function SettingsOutlet() {
  return (
    <section className='settings-section'>
        <SettingsMenu />
        <div className='settings-content'>
          <Outlet />
        </div>
    </section>
  );
}